import { ROLE_TYPES } from './constants';

// Single source of truth for role based on hostname only:
//   admin.website.com   -> admin
//   manager.website.com -> slh_manager
//   website.com (no subdomain) and others -> client
export function getRoleFromHostname(hostname = '') {
  if (hostname.startsWith('admin.')) return ROLE_TYPES.admin;
  if (hostname.startsWith('manager.')) return ROLE_TYPES.slh_manager;
  return ROLE_TYPES.client;
}
